import { cn } from "../lib/utils";

/**
 * Shape-matched placeholder while content loads; keeps layout stable. Use for known layouts; unknown-shape waits use `Spinner` (see the Loading Indicators taxonomy).
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-accent animate-pulse rounded-md", className)}
      {...props}
    />
  );
}

export { Skeleton };
